import { z } from 'zod';
import { Entity } from '../models/configuration.model';

const sdcBoTokenValue = z.string().regex(/^#[0-9a-f]{6}$/i);

export const configurationSchema = z.object({
  clientName: z.string(),
  appName: z.string(),
  logo: z.string(),
  favicon: z.string(),
  analytics: z.string(),
  theme: z.object({
    'main-color': z.string(),
    'secondary-color': z.string(),
    red: z.string(),
  }),
  sdcBoTheme: z.object({
    'sdc-bo-sidebar-bg': sdcBoTokenValue,
    'sdc-bo-sidebar-active-bg': sdcBoTokenValue,
    'sdc-bo-sidebar-active-expanded-bg': sdcBoTokenValue,
    'sdc-bo-header-fg': sdcBoTokenValue,
    'sdc-bo-login-panel-bg': sdcBoTokenValue,
    'sdc-bo-login-cta-bg': sdcBoTokenValue,
  }),
});

export const configurationData: Entity = {
  default: {
    clientName: 'Local',
    appName: 'Local',
    favicon: '/assets/icons/favicon.png',
    logo: '/assets/img/logo.svg',
    phone: '733-404-4242',
    email: 'cubsgrouptickets@cubs.com',
    analytics: '',
    theme: {
      'main-color': '77 139 219',
      'secondary-color': '39 46 64',
      red: '225 56 63',
    },
    sdcBoTheme: {
      'sdc-bo-sidebar-bg': '#4d8bdb',
      'sdc-bo-sidebar-active-bg': '#272e40',
      'sdc-bo-sidebar-active-expanded-bg': '#272e40',
      'sdc-bo-header-fg': '#4d8bdb',
      'sdc-bo-login-panel-bg': '#4d8bdb',
      'sdc-bo-login-cta-bg': '#272e40',
    },
  },
  chicagocubs: {
    clientName: 'Chicago Cubs',
    appName: 'Chicago Cubs',
    favicon: '/assets/img/chicagocubs/favicon.png',
    logo: '/assets/img/chicagocubs/logo.svg',
    phone: '733-404-4242',
    email: 'cubsgrouptickets@cubs.com',
    analytics: '',
    theme: {
      'main-color': '77 139 219',
      'secondary-color': '39 46 64',
      red: '225 56 63',
    },
    sdcBoTheme: {
      'sdc-bo-sidebar-bg': '#0e3386',
      'sdc-bo-sidebar-active-bg': '#cc3433',
      'sdc-bo-sidebar-active-expanded-bg': '#cc3433',
      'sdc-bo-header-fg': '#012d62',
      'sdc-bo-login-panel-bg': '#0e3386',
      'sdc-bo-login-cta-bg': '#cc3433',
    },
  },
  redsox: {
    clientName: 'Boston Red Sox',
    appName: 'Boston Red Sox',
    favicon: '/assets/img/redsox/favicon.png',
    logo: '/assets/img/redsox/logo.png',
    phone: '000-000-0000',
    email: 'none@3ddgitialvenue.com',
    analytics: '',
    theme: {
      'main-color': '13 43 86',
      'secondary-color': '189 48 57',
      red: '225 56 63',
    },
    sdcBoTheme: {
      'sdc-bo-sidebar-bg': '#0d2b56',
      'sdc-bo-sidebar-active-bg': '#bd3039',
      'sdc-bo-sidebar-active-expanded-bg': '#bd3039',
      'sdc-bo-header-fg': '#0d2b56',
      'sdc-bo-login-panel-bg': '#0d2b56',
      'sdc-bo-login-cta-bg': '#bd3039',
    },
  },
  houstonastros: {
    clientName: 'Houston Astros',
    appName: 'Houston Astros',
    favicon: '/assets/img/houstonastros/favicon.png',
    logo: '/assets/img/houstonastros/logo.png',
    phone: '000-000-0000',
    email: 'tickethelp@astros.com',
    analytics: '',
    theme: {
      'main-color': '00 44 97',
      'secondary-color': '235 132 31',
      red: '225 56 63',
    },
    sdcBoTheme: {
      'sdc-bo-sidebar-bg': '#012d62',
      'sdc-bo-sidebar-active-bg': '#f4911e',
      'sdc-bo-sidebar-active-expanded-bg': '#f4911e',
      'sdc-bo-header-fg': '#012d62',
      'sdc-bo-login-panel-bg': '#012d62',
      'sdc-bo-login-cta-bg': '#f4911e',
    },
  },
  pittsburghpirates: {
    clientName: 'Pittsburgh Pirates',
    appName: 'Pittsburgh Pirates',
    favicon: '/assets/img/pittsburghpirates/favicon.png',
    logo: '/assets/img/pittsburghpirates/logo.png',
    phone: '000-000-0000',
    email: 'none@3ddgitialvenue.com',
    analytics: '',
    theme: {
      'main-color': '38 37 31',
      'secondary-color': '253 194 36',
      red: '225 56 63',
    },
    sdcBoTheme: {
      'sdc-bo-sidebar-bg': '#26251f',
      'sdc-bo-sidebar-active-bg': '#fdc224',
      'sdc-bo-sidebar-active-expanded-bg': '#fdc224',
      'sdc-bo-header-fg': '#26251f',
      'sdc-bo-login-panel-bg': '#26251f',
      'sdc-bo-login-cta-bg': '#fdc224',
    },
  },
  miamimarlins: {
    clientName: 'Miami Marlins',
    appName: 'Miami Marlins',
    favicon: '/assets/img/miamimarlins/favicon.png',
    logo: '/assets/img/miamimarlins/logo.png',
    phone: '000-000-0000',
    email: 'none@3ddgitialvenue.com',
    analytics: '',
    theme: {
      'main-color': '00 163 224',
      'secondary-color': '00 00 00',
      red: '225 56 63',
    },
    sdcBoTheme: {
      'sdc-bo-sidebar-bg': '#000000',
      'sdc-bo-sidebar-active-bg': '#00a3e0',
      'sdc-bo-sidebar-active-expanded-bg': '#00a3e0',
      'sdc-bo-header-fg': '#000000',
      'sdc-bo-login-panel-bg': '#000000',
      'sdc-bo-login-cta-bg': '#00a3e0',
    },
  },
  chicagocubsspring: {
    clientName: 'Chicago Cubs Spring Training',
    appName: 'Chicago Cubs Spring',
    favicon: '/assets/img/chicagocubs/favicon.png',
    logo: '/assets/img/chicagocubs/logo.svg',
    phone: '733-404-4242',
    email: 'mesa@cubs.com',
    analytics: '',
    theme: {
      'main-color': '23 52 130',
      'secondary-color': '39 46 64',
      red: '225 56 63',
    },
    sdcBoTheme: {
      'sdc-bo-sidebar-bg': '#173482',
      'sdc-bo-sidebar-active-bg': '#272e40',
      'sdc-bo-sidebar-active-expanded-bg': '#272e40',
      'sdc-bo-header-fg': '#173482',
      'sdc-bo-login-panel-bg': '#173482',
      'sdc-bo-login-cta-bg': '#272e40',
    },
  },
  washingtonnationals: {
    clientName: 'Washington Nationals',
    appName: 'Washington Nationals',
    favicon: '/assets/img/washingtonnationals/favicon.png',
    logo: '/assets/img/washingtonnationals/logo.png',
    phone: '202-675-NATS (6287)',
    email: 'Ticket.info@nationals.com',
    analytics: '',
    theme: {
      'main-color': '00 00 00',
      'secondary-color': '187 13 48',
      red: '225 56 63',
    },
    sdcBoTheme: {
      'sdc-bo-sidebar-bg': '#000000',
      'sdc-bo-sidebar-active-bg': '#bb0d30',
      'sdc-bo-sidebar-active-expanded-bg': '#bb0d30',
      'sdc-bo-header-fg': '#000000',
      'sdc-bo-login-panel-bg': '#000000',
      'sdc-bo-login-cta-bg': '#bb0d30',
    },
  },
};
